


























































import { Vue, Component, Prop, Watch, Emit, Ref } from 'vue-property-decorator';
import { State } from 'vuex-class';
import Category from '../models/category';

@Component
export default class CategoryList extends Vue {

  get maxRowCount(): number {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return 3;
      case 'sm':
        return 3;
      case 'md':
        return 4;
      case 'lg':
        return 6;
      case 'xl':
        return 6;
      default:
        return 6;
    }
  }

  get showArrowsOnHover(): boolean {
    return this.$vuetify.breakpoint.mdAndUp;
  }

  get maxColumnCount(): number {
    return Math.floor(this.$vuetify.breakpoint.width / 80);
  }

  get pageSize(): number {
    return this.maxRowCount * this.maxColumnCount;
  }

  get categoryListHeight(): number {
    return this.maxRowCount * this.categoryTileHeight;
  }

  get page() {
    if (!this.categories) { return 0; }
    return Math.ceil(this.categories.length / this.pageSize);
  }

  get currentPateCategory() {
    return this.categories.slice(
      this.curPage * this.pageSize,
      (this.curPage + 1) * this.pageSize,
    );
  }
  @Prop(String) public readonly selectedId!: string;
  @State('localCategories') private categories!: Category[];

  private curPage = 0;

  private categoryTileHeight = 64;

  private windowInlineStyle = {
    height: `${this.categoryListHeight}px`,
  };

  public isSelected(item: Category): boolean {
    return this.selectedId === item.id;
  }
}
